<template>
  <div class="login_container">
    <div class="login_box">
      <div class="login_img">
        <img src="../assets/images/logo.png" alt />
      </div>

      <!-- 登录表单 -->
      <el-form v-loading.fullscreen.lock="loading" :model="loginForm" :rules="loginFormRules" ref="loginForm" label-width="70px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-user"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="vcode">
          <el-input v-model="loginForm.vcode" prefix-icon="el-icon-key" style="width:170px; margin-right: 15px"></el-input>
          <vue-img-verify @getImgCode="getImgCode" ref="vueImgVerify" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
        </el-form-item>
      </el-form>

      <div class="copyright">Copyright © 2018 - {{nowyear}} 江苏睿世力科技有限公司. 保留所有权利 <a href="http://www.beian.miit.gov.cn/" target="_blank">苏ICP备18014493号</a> </div>
    </div>
  </div>
</template>

<script>
import vueImgVerify from '../components/vue-img-verify'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        vcode: ''
      },
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        vcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '长度在4字符', trigger: 'blur' }
        ]
      },
      imgCode: '',
      nowyear: '现在'
    }
  },
  mounted () {
    // 检查登录状态
    this.checkLogin()
    // 绘制图片验证码
    this.imgCode = this.$refs.vueImgVerify.draw()
    this.nowyear = new Date().getFullYear()
  },
  methods: {
    submitForm (formName) {
      var that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.imgCode.trim().toUpperCase() == that.loginForm.vcode.trim().toUpperCase()) {
            that.erpLogin(that.loginForm.username, that.loginForm.password)
          } else {
            that.$alert('验证码错误!', '提示', {
              confirmButtonText: '确定',
              callback: action => {}
            })
            that.imgCode = that.$refs.vueImgVerify.draw()
          }
        } else {
          return false
        }
      })
    },
    erpLogin: function (loginname, password) {
      var that = this
      that.loading = true
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        timestamp: timestamp,
        loginname: loginname,
        password: password,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      axios.post(Vue.prototype.global.Url_ErpLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 保存数据
            localStorage.setItem('Useriderp', response.data.Useriderp)
            localStorage.setItem('Nicename', response.data.Nicename)
            localStorage.setItem('Authtokenerp', response.data.Authtokenerp)
            localStorage.setItem('Employeestype', response.data.Employeestype)
            localStorage.setItem('Jigouidneibu', response.data.Jigouidneibu)
            // 跳转
            that.$router.push('/Home')
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)

          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunAlertMsg("网络出错")
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    checkLogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 跳转
            that.$router.push('/Home')
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // 点击图片获取验证码
    getImgCode (code) {
      this.imgCode = code
    }
  },
  components: {
    vueImgVerify
  }
}
</script>

<style lang="less" scoped>
.login_container {
  position: relative;
  height: 100%;
  background: url(../assets/images/bg.jpg) no-repeat;
  background-size: 100%;
  .login_box {
    width: 460px;
    height: 360px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 1);
    position: fixed;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -45%);
    box-shadow: 0 0 14px 0px #3dace3;
    .login_img {
      width: 100px;
      height: 100px;
      line-height: 100px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      padding: 10px;
      transform: translate(-50%, -50%);
      border: 2px solid #fff;
      overflow: hidden;
      box-shadow: 0 0 10px 0px #b3dcf1;
      background-color: #e4f5ff;
      text-align: center;
      & img {
        width: 70%;
        height: 70%;
        margin: 14px auto 0 auto;
      }
    }
  }
  .copyright {
    margin-top: 400px;
    margin-left: -70px;
    text-align: center;
    color: #ffffff;
    width: 600px;

    & a{
      color:#ffffff;
      text-decoration: none;
    }
  }
}
.el-form {
  position: absolute;
  top: 96px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px 0 20px;
}
.el-button {
  width: 100%;
}
.img-verify{
  display: inline-block;
  vertical-align: -15px;
}
</style>
